// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DiamondIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DiamondIcon" ref={forwardedRef} {...props}>
      <path d="M10.707 1.513a1 1 0 0 0-1.414 0l-7.78 7.78a1 1 0 0 0 0 1.414l7.78 7.78a1 1 0 0 0 1.414 0l7.78-7.78a1 1 0 0 0 0-1.414zM10 2.927 17.073 10 10 17.073 2.927 10z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DiamondIcon = /* @__PURE__ */ Object.assign(DiamondIconComponent, {
  displayName: 'DiamondIcon',
});
